import { render, staticRenderFns } from "./Headerv2.vue?vue&type=template&id=8eb2dd3e&scoped=true&"
import script from "./Headerv2.vue?vue&type=script&lang=js&"
export * from "./Headerv2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8eb2dd3e",
  null
  
)

export default component.exports